export default {
  fetchUser: ({ isAgency }) => `${isAgency ? "agency/" : ""}auth/user`,
  fetchPartnerProfile: () => "partners/profile/basic-info",
  sendMessagingToken: ({ persona }) => {
    if (persona === "agency") return "agency/notifications/device-tokens"
    return "notifications/device-tokens"
  },
  getCurrencyRate: ({ currency }) => `currencies/rates/${currency}`,
}
